// @vue/component

export default {
  name: 'FaqPage',
  data() {
    return {
      promotionData: {},
      activeFaq: 0,
      isLoading: false,
    };
  },

  async created() {
    this.isLoading = true;
    await this.$store.dispatch('promotions/getPromotionsData');
    this.promotionData = this.$store.getters['promotions/promotionsData'][0];
    this.isLoading = false;
  },
};
